import Bacon from 'baconjs';

export default function (dispatcher) {
    const {push, stream} = dispatcher;
    const urlStream = stream('URL').map('.query.q');

    const selected = Bacon.update(
        undefined,
        [urlStream],
        (unused, newValue) => newValue,
        [stream('SEARCH-UPDATE')],
        (unused, newValue) => (newValue.length ? `${newValue}` : null),
        [stream('SEARCH-CLEAR').merge(stream('FILTERS-REMOVE-ALL'))],
        () => undefined
    );

    return Bacon.combineTemplate({
        selected,

        updateSearch(searchString) {
            push('SEARCH-UPDATE', searchString);
        },
        clearSearch() {
            push('SEARCH-CLEAR');
        },
    });
}
